exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".times-up-modal div {\n  text-align: center;\n}\n.times-up-modal div.modal-header {\n  padding-top: 40px;\n  border-bottom: none;\n}\n.times-up-modal div.modal-header i {\n  font-size: 64px;\n  color: #f0ad4e;\n}\n.times-up-modal div.modal-header div.modal-title {\n  font-size: 44px;\n  padding-top: 10px;\n  font-weight: 900;\n}\n.times-up-modal div.modal-body {\n  font-size: 16px;\n}\n.times-up-modal div.modal-footer {\n  border-top: none;\n  padding-bottom: 30px;\n}\n.times-up-modal div.modal-footer .btn {\n  padding: 15px 48px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./frontend/olos/styles/TimesUpModal.styl
// module id = 1917
// module chunks = 1